import { parse } from 'date-fns';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { IMedication } from 'infrastructure/interfaces';

interface MedicationInfoProps {
  item: IMedication;
}

const transformDate = (date: string | null) =>
  date
    ? DateFormatter({
        date: parse(date, 'MMM dd yyyy', new Date()),
        format: DateFormats['MM/dd/yyyy'],
      })
    : '';

export const MedicationInfo: React.FC<MedicationInfoProps> = ({ item }) => {
  const { t } = useTranslation();
  const startDate = transformDate(item.startDate);
  const endDate = transformDate(item.endDate);
  const onGoing = t('labels.onGoing');
  let dateRange: string | undefined;
  if (startDate && endDate) {
    dateRange = `${startDate} - ${endDate}`;
  } else if (startDate) {
    dateRange = `${startDate} - ${onGoing}`;
  } else {
    dateRange = endDate || undefined;
  }

  const values = [
    item.route,
    item.duration,
    item.dosage,
    item.frequency,
    dateRange,
  ].filter(Boolean);

  return (
    <div className={s['body-left']}>
      <p
        className={s['body-left-values']}
        data-cy="medication-description-values"
      >
        {values.map((val, idx) => (
          <React.Fragment key={idx}>
            <span>{val}</span>
          </React.Fragment>
        ))}
        {values.length > 0 && <span className={s['body-left-pipe']}>|</span>}
        <div>
          <span className={s['body-left-note-label']}>
            {t('labels.note')}:{' '}
          </span>
          <span data-cy="medication-description-note">{item.note || '-'}</span>
        </div>
      </p>
    </div>
  );
};
